if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const targetMediaId = this.openedBy.getAttribute('data-media-id');
        const slider = this.querySelector('.product-media-modal__list');
        const activeSlide = this.querySelector(`[data-media-id="${targetMediaId}"]`);

        if (!activeSlide || !slider) return;

        // Scroll the slider to the active slide
        activeSlide.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'start' });

        // Load deferred media content if it's a YouTube video
        const deferredMedia = activeSlide.querySelector('deferred-media');
        if (deferredMedia) {
          const activeMediaTemplate = deferredMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

          if (
            deferredMedia.nodeName == 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          ) {
            deferredMedia.loadContent();
          }
        }
      }
    }
  );
}
